import { render, staticRenderFns } from "./the-new-version-modal.vue?vue&type=template&id=e2ace7f8&"
import script from "./the-new-version-modal.vue?vue&type=script&lang=js&"
export * from "./the-new-version-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2ace7f8')) {
      api.createRecord('e2ace7f8', component.options)
    } else {
      api.reload('e2ace7f8', component.options)
    }
    module.hot.accept("./the-new-version-modal.vue?vue&type=template&id=e2ace7f8&", function () {
      api.rerender('e2ace7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/the-new-version-modal.vue"
export default component.exports